exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".enrollment-management-app .segmented-table td[data-column=\"status\"] {\n  width: 5%;\n}\n", ""]);
